import { Box } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { getCurrentMode } from '../../store/redux/reducers/darkModeSlice'
import navigation from '../../config/navigation'
import { useNavigate } from 'react-router-dom'
import { environment } from '../../enviroments/enviroment'

const logoLight = `${environment.publicUrl}/assets/image/bee2code_logo_black.svg`
const logoDark = `${environment.publicUrl}/assets/image/bee2code_logo_white.svg`
const logoIcon = `${environment.publicUrl}/assets/image/bee2code_logo_icon.svg`

type LogoProps = {
  iconVariant?: boolean
  hover?: boolean
}

const Logo = ({ iconVariant, hover }: LogoProps) => {
  const mode = useSelector(getCurrentMode)
  const navigate = useNavigate()

  return (
    <>
      <Box
        alt={'Logo, Beecrew'}
        component={'img'}
        src={logoIcon}
        sx={{
          display: iconVariant ? 'auto' : 'none',
          width: '100%',
          height: '35px',
          ml: 0,
          ':hover': {
            cursor: hover ? 'pointer' : 'default',
          },
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            navigate(navigation.home)
          }
        }}
        tabIndex={0}
      />
      <Box
        alt={'Logo, Beecrew'}
        component={'img'}
        src={mode === 'light' ? logoLight : logoDark}
        sx={{
          display: !iconVariant ? 'auto' : 'none',
          width:'112px',
          height: '35px',
          ml: '-8px',
          ':hover': {
            cursor: hover ? 'pointer' : 'default',
          },
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            navigate(navigation.home)
          }
        }}
        tabIndex={0}
      />
    </>
  )
}

export default Logo
